import { render, staticRenderFns } from "./PostingDestinationListItem.vue?vue&type=template&id=76ff217a&scoped=true&"
import script from "./PostingDestinationListItem.vue?vue&type=script&lang=js&"
export * from "./PostingDestinationListItem.vue?vue&type=script&lang=js&"
import style0 from "./PostingDestinationListItem.vue?vue&type=style&index=0&id=76ff217a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ff217a",
  null
  
)

export default component.exports